import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CognitoLanguageMappingService {
  
  private readonly COGNITO_SUPPORTED_LANGUAGES = [
    'en',
    'es', 
    'fr',
    'de',
    'it',
    'pt-BR',
  ];

  private readonly LANGUAGE_MAPPING: Record<string, string> = {
    'fr-CA': 'fr',
    'fr-FR': 'fr',    
    'es-MX': 'es',
    'pt-PT': 'pt-BR',
  };

  mapToCognitoSupportedLanguage(languageCode: string): string {
    if (!languageCode || typeof languageCode !== 'string') {
      console.warn('Invalid language code provided to Cognito mapping service');
      return 'en';
    }

    if (this.COGNITO_SUPPORTED_LANGUAGES.includes(languageCode)) {
      return languageCode;
    }

    const mappedLanguage = this.LANGUAGE_MAPPING[languageCode];
    if (mappedLanguage) {
      console.log(`Mapped unsupported language '${languageCode}' to Cognito-supported '${mappedLanguage}'`);
      return mappedLanguage;
    }

    const baseLanguage = languageCode.split('-')[0];
    if (this.COGNITO_SUPPORTED_LANGUAGES.includes(baseLanguage)) {
      console.log(`Mapped regional language '${languageCode}' to base language '${baseLanguage}'`);
      return baseLanguage;
    }

    console.warn(`No Cognito mapping found for language '${languageCode}', defaulting to English`);
    return 'en';
  }
}
